import React, { useState, useEffect } from 'react';

const FadeAlert: React.FC<{ errorMessage: string | null }> = ({ errorMessage }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (errorMessage) {
      // First hide the alert if it's already visible (to restart the animation)
      setIsVisible(false);

      // Show the alert again after a short delay
      const showTimeout = setTimeout(() => {
        setIsVisible(true);
      }, 100); // Delay to reset visibility and restart the animation

      // Hide the alert after 3 seconds
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 3100); // Total delay of 3 seconds (100ms to reset + 3000ms for visibility)

      // Clear timeouts when the component is unmounted or the error message changes
      return () => {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
      };
    }
  }, [errorMessage]);

  return (
    <div className={`fade-alert ${isVisible ? 'fade-alert-fade-in' : 'fade-alert-fade-out'}`}>
      {errorMessage}
    </div>
  );
};

export default FadeAlert;
